import { render, staticRenderFns } from "./RestAreaModal.vue?vue&type=template&id=620102ea&"
import script from "./RestAreaModal.vue?vue&type=script&lang=js&"
export * from "./RestAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports